import { Paper } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Draggable from "react-draggable";
import styled from "styled-components";

const API_URL = `${window.location.origin}/api`;
const APP_URL = "http://ocop.quangnam.vn";
// const API_URL = "http://14.241.134.16:8785";
// const APP_URL = "http://14.241.134.16:8786";

export const API_URL_DOWNLOAD = "http://14.241.134.16:8785/media/";
export const CODE_QUANGNAM = 49;
export const CODE_DIENBAN = 502;
export const ID_GROUP_CAPTINH = 9;
export const ID_HOIDONG = 6;
//kiểm tra đang đăng nhập với nhóm chủ thể
const ID_GROUP_CHUTHE = 5;
//kiểm tra đang đăng nhập với nhóm hội đồng = 6
const ID_GROUP_HOIDONG = 6;
//Kiểm tra nhóm người dùng là 1
const ID_GROUP_NUMBER_ONE = 1;
//kiểm tra nhóm người dùng là 7
const ID_GROUP_NUMBER_SEVEN = 7;
// kiểm tra nhóm người dùng cấp phường/xã
const ID_GROUP_PHUONGXA = 8;

export const API_ROUTES = {
  RESET_PASSWORD: `${API_URL}/api/v1/password_reset`,
  ALLHUYEN: `${API_URL}/api/v1/tinh/huyen?tinh=${CODE_QUANGNAM}`,
  ALLXA: `${API_URL}/api/v1/huyen/xa?tinh=${CODE_QUANGNAM}`,
  GETHUYEN: `${API_URL}/api/v1/tinh/huyen`,
  GETXA: `${API_URL}/api/v1/huyen/xa`,
  TINH: `${API_URL}/api/v1/tinh`,
  LOAIHINH: `${API_URL}/api/v1/loaihinh`,
  NHOMBOTIEUCHI: `${API_URL}/api/v1/nhombotieuchi`,
  BOTIEUCHI: `${API_URL}/api/v1/botieuchi`,
  USER: `${API_URL}/api/v1/user`,
  DASHBOARD: `${API_URL}/api/v1/dashboard`,
  TRANGTHAI: `${API_URL}/api/v1/trangthai`,
  DANTOC: `${API_URL}/api/v1/dantoc`,
  QUOCGIA: `${API_URL}/api/v1/quocgia`,
  NHOMNGANHNGHE: `${API_URL}/api/v1/nhomnganhnghe`,
  NGANHNGHE: `${API_URL}/api/v1/nganhnghe`,
  NHOMSANPHAM: `${API_URL}/api/v1/nhomsanpham`,
  VANBAN: `${API_URL}/api/v1/vanban`,
  SANPHAM: `${API_URL}/api/v1/sanphamocop`,
  LOAIVANBAN: `${API_URL}/api/v1/loaivanban`,
  QUANLYCHUTHE: `${API_URL}/api/v1/chuthe`,
  THANHVIEN: `${API_URL}/api/v1/thanhvien`,
  HOIDONG: `${API_URL}/api/v1/hoidong`,
  PHIEUDANGKY: `${API_URL}/api/v1/dangkysanpham`,
  DONVI: `${API_URL}/api/v1/donvi`,
  REGISTER: `${API_URL}/api/v1/register`,
  LISTUSER: `${API_URL}/api/v1/listusers`,
  TINTUC: `${API_URL}/api/v1/tintuc`,
  GIOITHIEU: `${API_URL}/api/v1/gioithieu`,
  CHAMDIEM: `${API_URL}/api/v1/chamdiem`,
  NHOMCHA: `${API_URL}/api/v1/nhomchabotieuchi`,
  GETHOSOCHAMDIEM: `${API_URL}/api/v1/gethosochamdiem`,
  GETHOSOCHAMDIEMCAPTINH: `${API_URL}/api/v1/gethosochamdiemcaptinh`,
  GETPHIEUDANGKY: `${API_URL}/api/v1/getphieudangky`,
  HOIDONGCHAMDIEM: `${API_URL}/api/v1/hoidongchamdiem`,
  THONGKESANPHAMDONVI: `${API_URL}/api/v1/thongkesanphamdonvi`,
  GOITHONGBAO: `${API_URL}/api/v1/goithongtinchuthe`,
  CAPNHATTRANGTHAI: `${API_URL}/api/v1/capnhattrangthai`,
  CAPNHAPTRANGTHAITHANHVIEN: `${API_URL}/api/v1/capnhattrangthaithanhvien`,
  THONGBAO: `${API_URL}/api/v1/thongbao`,
  CAPNHAPCAPQUANLYPHIEUDANGKY: `${API_URL}/api/v1/capnhatcapquanlyphieudangky`,
  CAPNHAPTRANGTHAITRAPHIEUDANGKY: `${API_URL}/api/v1/capnhattrangthaitraphieudangky`,
  CAPNHAPTRANGTHAITRAPHIEUDANGKYCAPTINH: `${API_URL}/api/v1/capnhattrangthaitraphieudangkycaptinh`,
  THONGKESANPHAM: `${API_URL}/api/v1/thongkesanpham`,
  PHIEUDANGKYCAPTINH: `${API_URL}/api/v2/dangkysanpham`,
  HOIDONGCHAMDIEMCAPTINH: `${API_URL}/api/v1/hoidongcaptinh`,
  HOIDONGCAPTINHCHAMDIEM: `${API_URL}/api/v1/hoidongcaptinhchamdiem`,
  HANG: `${API_URL}/api/v1/hang`,
  SETTING: `${API_URL}/api/v1/setting`,
  ACTIONLOG: `${API_URL}/api/v1/actionlog`,
  EXTENSIONFILE: `${API_URL}/api/v1/extension`,
  DOWNLOADFILE: `${API_URL}/api/v1/download-backup`,
};

export const API_ROUTES_V2 = {
  DETAILHUYEN: `${API_URL}/api/v2/gethuyen/{code}`,
  DETAILXA: `${API_URL}/api/v2/getxa/{code}`,
  SANPHAM: `${API_URL}/api/v2/sanpham`,
  PHIEUDANGKY: `${API_URL}/api/v2/dangkysanpham`,
  PHIEUDANGKYCAPTINH: `${API_URL}/api/v2/dangkysanphamcaptinh`,
  CHAMDIEM: `${API_URL}/api/v2/chamdiem`,
  HOIDONGCHAMDIEM: `${API_URL}/api/v2/hoidongchamdiem`,
};

export const APP_ROUTES = {
  SIGN_IN: "/authentication/sign-up",
  DASHBOARD: "/dashboard",
};

export const LINK_API = {
  allTinh: "tinh",
  getHuyen: "tinh/{id}/huyen",
  getXa: "huyen/{id}/xa",
};

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    // width: 300,
  },
  indeterminateColor: {
    color: "#f50057",
  },
  selectAllText: {
    fontWeight: 500,
  },
  selectedAll: {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.08)",
    },
  },
  customAutocomplete: {
    "& .MuiAutocomplete-listbox": {
      // maxHeight: "300px", // Adjust the height as needed
      padding: "8px 4px 4px 8px !important",
    },
  },
  customPaper: {
    position: "fixed !important",
    top: "65px !important",
    height: "calc(100vh - 65px) !important",
    margin: "0 !important",
    backgroundColor: "#fff !important",
  },
  menuItem: {
    "&:hover": {
      backgroundColor: "#f0f2f5 !important",
      color: "#3F51B5",
    },
  },
  menuSliderContainer: {
    width: 350,
    // background: "#511",
    height: "100%",
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
  // getContentAnchorEl: null,
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "center",
  },
  variant: "menu",
};

export function hasChildren(item) {
  const { items: children } = item;

  if (children === undefined) {
    return false;
  }

  if (children.constructor !== Array) {
    return false;
  }

  if (children.length === 0) {
    return false;
  }

  return true;
}

export function convertNumbersToStrings(obj) {
  for (const key in obj) {
    if (typeof obj[key] === "number") {
      obj[key] = obj[key].toString();
    } else if (typeof obj[key] === "object") {
      convertNumbersToStrings(obj[key]);
    }
  }
  return obj;
}

export function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const allowedFileTypes = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
  "application/vnd.ms-excel", // .xls
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/bmp",
  "image/svg+xml", // image/*
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .doc, .docx
  "application/pdf", // .pdf
  "application/zip",
  "application/x-rar-compressed", // .zip, .rar
];

export const PermissionMenuKey = {
  home: "home",
  dashboard: "dashboard",
  users: "users",
  users2: "active",
  backupfile: "backup",
  roles: "roles",
  menu: "menu",
  groupMenu: "groupmenu",
  //
  donVi: "donvi",
  thanhvien: "thanhvien",
  hoidong: "hoidong",
  sanpham: "sanpham",
  phieudangky: "phieudangky",
  quanlychuthe: "quanlychuthe",
  //Danh mục
  donViHanhChinh: "donvihanhchinh",
  loaiHinh: "loaihinh",
  nhomNganh: "nhomnganh",
  nganhNghe: "nganhnghe",
  nhomSanpham: "nhomsanpham",
  nhomChaBotieuchi: "nhomchabotieuchi",
  nhomBotieuchi: "nhombotieuchi",
  boTieuchi: "botieuchi",
  quanlyvanban: "quanlyvanban",
  loaiVanban: "loaivanban",
  //baocao
  baocaolodat: "baocaolodat",
  tinhhinhlaodong: "tinhhinhlaodong",
  diadiem: "diadiem",
  loaidiadiem: "loaidiadiem",
  tyleLapday: "tylelapday",
  tinhhinhSuDungDat: "tinhhinhsudungdat",
  cocauSuDungDat: "cocausudungdat",
  SuDungDatDuAn: "thongkeduansudungdat",
  baocaothongke: "baocaothongke",
  baocaoKhuCumCN: "baocaokhucumcn",
  baocaoDoanhNghiep: "baocaodoanhnghiep",
  baocaoDuAn: "baocaoduan",
  baocaoTyleLapday: "baocaotylelapday",
  baocaoTinhhinhSuDungDat: "baocaotinhhinhsudungdat",
  baocaoCocauSuDungDat: "baocaococausudungdat",
  baocaoThongKeSuDungDatDuAn: "baocaothongkesudungdatduan",
  //new
  gioiThieu: "gioithieu",
  tinTuc: "tintuc",
  dangKyChuThe: "dangkychuthe",
  chamdiem: "chamdiem",
  chamdiemhoso: "chamdiemhoso",
  chamdiemhosocaptinh: "chamdiemcaptinh",
  quanLyTinTuc: "quanlytintuc",
  quanLyGioiThieu: "quanlygioithieu",
  moHoidongchamdiem: "hoidongchamdiem",
  hoSoDangKy: "hosodangky",
  chiTietTinTuc: "chitiettintuc",
  chiTietChamDiem: "chitietchamdiem",
  chiTietChamDiemCapTinh: "chitietchamdiemcaptinh",
  thongKeSanPham: "thongkesanpham",
  // hội đồng cấp tỉnh
  ocopcaptinh: "ocopcaptinh",
  hosodangkycaptinh: "hosodangkycaptinh",
  tongHopSanPhamOCOP: "tonghopsanphamocop",
  thongKeChuthe: "thongkechuthe",
  hang: "hang",
  quanlyGiayPhep: "quanlygiaychungnhan",
  quanlyGiayPhep_1048: "giaychungnhan1048",
  danhGiaHoSo: "danhgiahoso",
  setting: "setting",
  thongTinSanPham: "thongtinsanpham",
  actionLog: "actionlog",
  extensionFile: "extensionfile",
  share: "share",
};
export const ModeAuthorizeEnum = {
  view: "view",
  access: "access",
};
export const KEY_ENUM_TYPE_PLACE = {
  khuCN: "khuCN",
  cumCN: "cumCN",
  thuongmai: "thuongmai",
  sieuThi: "sieuThi",
  cho: "cho",
  trumTamTM: "trumTamTM",
  minimart: "minimart",
  cuaHangTienLoi: "cuaHangTienLoi",
  hoi: "hoi",
  hiepHoi: "hiepHoi",
  hopTacXa: "hopTacXa",
  cuaHangXangDau: "cuaHangXangDau",
  nangluong: "nangluong",
  dapThuyDien: "dapThuyDien",
  hoChua: "hoChua",
  thuyDien: "thuyDien",
  doanhNghiep: "doanhNghiep",
  duAn: "duan",
  khuKinhTe: "khukinhte",
};

export const CUSTOM_ROLE = {
  4: {
    id: 4,
    ten: "Cấp TW",
  },
  3: {
    id: 3,
    ten: "Cấp tỉnh thành",
  },
  2: {
    id: 2,
    ten: "Cấp quận/huyện",
  },
  1: {
    id: 1,
    ten: "Cấp phường/xã",
  },
};
export const CUSTOM_HANG = {
  1: {
    id: 1,
    ten: "1 sao",
  },
  2: {
    id: 2,
    ten: "2 sao",
  },
  3: {
    id: 3,
    ten: "3 sao",
  },
  4: {
    id: 4,
    ten: "4 sao",
  },
  5: {
    id: 5,
    ten: "5 sao",
  },
};

export const CUSTOM_PHAN_LOAI_DAP = {
  1: {
    id: 1,
    ten: "Lớn",
  },
  2: {
    id: 2,
    ten: "Trung bình",
  },
  3: {
    id: 3,
    ten: "Nhỏ",
  },
};
export const STATUS_USE_LAND = {
  1: "Đang sử dụng",
  2: "Chưa cấp",
};
const chunkSubstr = (str, size) => {
  if (str && size && typeof str == "string") {
    const numChunks = Math.ceil(str.length / size);
    const chunks = new Array(numChunks);

    for (let i = 0, o = 0; i < numChunks; ++i, o += size) {
      chunks[i] = str.substr(o, size);
    }

    return chunks;
  } else return str;
};

const ALLVALUE = { ma: "ALL", ten: "Tất cả" };
export {
  API_URL,
  APP_URL,
  MenuProps,
  VisuallyHiddenInput,
  allowedFileTypes,
  useStyles,
  ID_GROUP_CHUTHE,
  ID_GROUP_HOIDONG,
  ID_GROUP_NUMBER_ONE,
  ID_GROUP_NUMBER_SEVEN,
  ID_GROUP_PHUONGXA,
  chunkSubstr,
  ALLVALUE,
};

export function convertToTitleCase(str) {
  if (!str) return "";
  // Chuyển đổi toàn bộ chuỗi thành chữ thường
  str = str.toLowerCase();
  // Chuyển đổi ký tự đầu tiên thành chữ hoa
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function validateArrayFileRequired(arrayFiles, dungluong_file) {
  let result = [];
  if (arrayFiles) {
    arrayFiles.map((file, index) => {
      result.push("");
      if (!file?.name?.length) {
        result[index] = "Tệp không được trống";
      } else {
        const fileSizeInMB = file?.size / (1024 * 1024);
        if (fileSizeInMB > dungluong_file) {
          result[index] =
            "Kích thước tệp quá lớn. Tệp upload phải nhỏ hơn " +
            dungluong_file +
            "MB";
        }
      }
    });
  }
  return result;
}
//Kiểm tra nhóm người dùng với id Group
export function checkGroupUser(user, idGroup) {
  let check = false;
  if (user && user.id) {
    if (user?.group?.find((item) => item?.id == idGroup)) {
      check = true;
    }
  }
  return check;
}

export const checkUrlTep = (string) => {
  let result = string;
  if (string.includes("/media/")) {
    result = string.replace("/media/", "");
  }
  return result;
};
